export const MEDICATION_STATUS = ["Active", "Discontinued"];

export const MEDICATION_ROUTES = [
  "Oral",
  "Inhalation",
  "Topical",
  "Injection",
  "Intravenous",
  "Sublingual",
  "Rectal",
  "Other",
];

export const MEDICATION_FREQUENCIES = [
  "Once daily",
  "Twice daily",
  "Three times daily",
  "Four times daily",
  "Every other day",
  "Weekly",
  "As needed",
  "Other",
];

export const STATUS_FILTER_OPTIONS = [
  { value: "", label: "All Status" },
  { value: "Active", label: "Active" },
  { value: "Discontinued", label: "Discontinued" },
];

export const STATUS_BADGE = {
  Active: {
    wrap: "bg-emerald-50 text-emerald-800 border-emerald-200",
    dot: "bg-emerald-500",
  },
  Discontinued: {
    wrap: "bg-rose-50 text-rose-800 border-rose-200",
    dot: "bg-rose-500",
  },
};
